import Button from "@/components/Button";
import { Path, useNavigate } from "@/router";

type DashboardTextLinkProps = {
  children: string;
  onClick?: () => void;
  to?: Path;
  testId?: string;
};

export default function DashboardTextLink({ children, onClick, to, testId }: DashboardTextLinkProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    if (to) {
      navigate(to);
    }
  };

  return (
    <Button variant="text" onClick={handleClick} testId={testId} disabled={!onClick && !to}>
      {children}
    </Button>
  );
}
